<template>
  <div id="cashcreation">
    <div class="header-text">
      <h1>劵详情-查看</h1>
      <div class="buttom-div">
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form
            disabled
            :label-position="labelPosition"
            label-width="150px"
            size="small"
            class="form-div"
            ref="BasicInformation"
            :model="SecuritiesDetails"
          >
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="劵编码">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.coupCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="劵名称">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.couponsName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="劵类型">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.couponsKText"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="券库编号">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.coupGrpNo"
                    @click.native="OnclickConponesName(SecuritiesDetails)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="劵库后台名称">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.innerCoupName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="劵金额"
                  v-if="CouponsSelectChang.couponsKind == 0"
                >
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.coupValue"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="劵折扣"
                  v-else-if="CouponsSelectChang.couponsKind == 1"
                >
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.coupValue"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="礼品编号"
                  v-else-if="CouponsSelectChang.couponsKind == 2"
                >
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.giftID"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="劵密码"
                  v-else-if="CouponsSelectChang.couponsKind == 3"
                >
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.coupPwd"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="会员名称">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.custName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="领取时间">
                  <el-input
                    readonly
                    :value="renderTime(SecuritiesDetails.postTime)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="会员卡号">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.cardNO"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="状态">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.stateText"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="100" v-if="CouponsSelectChang.couponsKind == 2">
              <el-col :span="9">
                <el-form-item label="赠送人">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.transfererName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="礼品名称">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.giftName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="有效期起始时间">
                  <el-input
                    readonly
                    :value="renderTime(SecuritiesDetails.startDate)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="有效期结束时间">
                  <el-input
                    readonly
                    :value="renderTime(SecuritiesDetails.endDate)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="100"
              style="border-top: 1px solid #808080; padding-top: 15px"
            >
              <el-col :span="9">
                <el-form-item label="劵发放方式">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.releaseModeText"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="积分商城商品">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.commodityName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="积分商城兑换记录">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.redemptionNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="活动名称">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.campaignName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="100"
              style="border-top: 1px solid #808080; padding-top: 15px"
            >
              <el-col :span="9">
                <el-form-item label="核销类型">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.veriModeText"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="POS领取礼品单据号">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.getNo"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col
                :span="9"
                v-if="
                  CouponsSelectChang.couponsKind == 0 ||
                  CouponsSelectChang.couponsKind == 1
                "
              >
                <el-form-item label="销售单号">
                  <el-input
                    readonly
                    v-model="SecuritiesDetails.saleNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="使用时间">
                  <el-input
                    readonly
                    :value="renderTime(SecuritiesDetails.useTime)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100"  style="border-top: 1px solid #808080; padding-top: 15px" v-if="CouponsSelectChang.state == 2">
              <el-col :span="9">
                <el-form-item label="禁用人">
                  <el-input
                      readonly
                      v-model="SecuritiesDetails.manualVeriUser"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="禁用时间">
                  <el-input
                      readonly
                      :value="renderTime(SecuritiesDetails.manualVeriTime)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="100"
              style="border-top: 1px solid #808080; padding-top: 15px"
            >
              <h4 style="margin-left: 8%; margin-bottom: 15px">赠送记录</h4>
              <div style="width: 600px; margin-left: 8%">
                <el-table
                  height="300"
                  size="small"
                  class="table-style"
                  border
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    background: '#FCFBF2',
                    'text-align': 'center',
                    color: '#6C6839',
                    fontSize: '14px',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                  :data="dataSource"
                  tooltip-effect="dark"
                  style="width: 100%"
                  v-loading="Options.loading"
                >
                  <el-table-column type="index" width="60"></el-table-column>
                  <el-table-column
                    width="160"
                    prop="transferCustName"
                    label="赠送人"
                  ></el-table-column>
                  <el-table-column
                    width="160"
                    prop="receiverCustName"
                    label="接受人"
                  ></el-table-column>
                  <el-table-column prop="giveTime" label="转赠日期">
                    <template slot-scope="scope">
                      {{ renderTime(scope.row.giveTime || "") }}
                    </template></el-table-column
                  >
                </el-table>
              </div>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { giftRecord } from "@/api/viewMemberModule";
import { queryByCoupID } from "@/api/couponsDepot.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      labelPosition: "right",
      SecuritiesDetails: {},
      dataSource: [],
      Options: {
        loading: false,
      },
    };
  },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
  },
  mounted() {
    this.getInfoList();
    this.RqueryByCoupID();
  },
  methods: {
    getInfoList() {
      this.Options.loading = true;
      let data = require("qs").stringify({
        coupID: this.CouponsSelectChang.coupID,
      });
      giftRecord(data).then((res) => {
        if (res.success == true) {
          this.dataSource = res.data;
        } else {
          this.$message.error(res.message);
        }
        this.Options.loading = false;
      });
    },
    OnclickConponesName(row) {
      this.$store.dispatch("user/USetCouponsSelectChang", row);
      localStorage.setItem("CouponsSelectChang", JSON.stringify(row));
      if (row.couponsKText == "现金券") {
        this.$router.push("/ViewDetails");
      } else if (row.couponsKText == "礼品券") {
        this.$router.push("/GiftLookup");
      } else if (row.couponsKText == "折扣券") {
        this.$router.push("/RebateDetails");
      } else if (row.couponsKText == "异业券") {
        this.$router.push("/AbnormalLook");
      }
    },
    RqueryByCoupID() {
      let data = require("qs").stringify({
        coupID: this.CouponsSelectChang.coupID,
      });

      queryByCoupID(data).then((res) => {
        if (res.success) {
          let CopyData = res.data;
          CopyData.couponsKText = this.returncouponsKText(
            parseInt(CopyData.couponsKind)
          );
          CopyData.stateText = this.returnStateText(parseInt(CopyData.state));

          CopyData.veriModeText = this.returnVeriModeText(
            parseInt(CopyData.veriMode)
          );

          parseInt(CopyData.veriModeText)
          CopyData.releaseModeText = this.returnReleaseModeText(
            parseInt(CopyData.releaseMode)
          );
          this.SecuritiesDetails = CopyData;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    returnReleaseModeText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "营销发券";
          break;
        case 1:
          text = "积分兑换";
          break;
        case 2:
          text = "扫码领券";
          break;
      }
      return text;
    },
    returnVeriModeText(type) {
      let text = "";
      switch (type) {
        case 1:
          text = "销售核销";
          break;
        case 2:
          text = "领取核销";
          break;
        case 3:
          text = "手工核销";
          break;
        case 4:
          text = "邮购";
          break;
      }
      return text;
    },
    returnStateText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "有效";
          break;
        case 1:
          text = "已核销";
          break;
        case 2:
          text = "已禁用";
          break;
        case 3:
          text = "未发放";
          break;
        case 4:
          text = "无效";
          break;
        case 5:
          text = "已过期";
          break;
      }
      return text;
    },
    returncouponsKText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "现金券";
          break;
        case 1:
          text = "折扣券";
          break;
        case 2:
          text = "礼品券";
          break;
        case 3:
          text = "异业券";
          break;
      }
      return text;
    },
    renderTime(date) {
      //格式化时间
      if (date) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-magin {
  margin-top: -30px;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.search-div {
  display: flex;
  justify-content: flex-end;
}
.elUpload {
  box-sizing: border-box;
  border: none;
  display: flex;
  justify-content: center;
  width: 98px;
  height: 34px;
}
.buttom-flex {
  display: flex;
  flex-direction: row;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.margig-left80 {
  margin-left: 80px !important;
}
.formClass {
  margin-top: 10px;
}
.SelectArea {
  display: flex;
  margin-top: 8px;
  width: 140px;
}
.CategoryFiltering-div-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.CategoryFiltering-div {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.CategoryFiltering-conter {
  // border: 1px solid #a8a8a8;
  display: flex;
  width: 1120px;
  height: 100%;
  margin-top: -15px;
}
.CategoryFiltering {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 700px;
  margin-top: 20px;
}
.right-top {
  display: flex;
  flex-direction: column;
  height: 430px;
}
.right-buttom {
  display: flex;
  flex-direction: column;
  height: 430px;
  margin-top: 20px;
}
.part-class-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.part-class-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 470px;
}
.Coupons-part {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 50px;
}
.Conpone-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 50px;
}
.MaturityOfSecurities {
  display: flex;
}
.periodOfValidity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-div {
  padding: 20px 0px;
  padding-left: 100px;
}
.textareaClass {
  resize: none;
  width: 100%;
}
.textareaClass-store {
  padding: 2px 10px;
}
#cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
.header-text {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 50px;
  background-color: #e3e3e3;
}
::v-deep {
  .el-card__body {
    padding: 20px 0 20px 0;
  }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>
